// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tables from './pages/Tables';
import Session from './pages/Session';
import Food from './pages/Food';
import Inventory from './pages/Inventory';
import Customers from './pages/Customers';
import Billing from './pages/Billing';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Team from './pages/Team';

function PrivateRoute({ children, adminOnly = false }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"/></div>;
  if (!user)   return <Navigate to="/login" replace/>;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace/>;
  return children;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  return user ? <Navigate to="/" replace/> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Toaster position="top-right" toastOptions={{ duration: 3500 }}/>
          <Routes>
            <Route path="/login" element={<PublicRoute><Login/></PublicRoute>}/>
            <Route path="/" element={<PrivateRoute><Layout/></PrivateRoute>}>
              <Route index element={<Dashboard/>}/>
              <Route path="tables"    element={<Tables/>}/>
              <Route path="session/:id" element={<Session/>}/>
              <Route path="billing"   element={<Billing/>}/>
              <Route path="reports"   element={<Reports/>}/>
              <Route path="settings"  element={<Settings/>}/>
              <Route path="food"      element={<PrivateRoute adminOnly><Food/></PrivateRoute>}/>
              <Route path="inventory" element={<PrivateRoute adminOnly><Inventory/></PrivateRoute>}/>
              <Route path="customers" element={<PrivateRoute adminOnly><Customers/></PrivateRoute>}/>
              <Route path="team"      element={<PrivateRoute adminOnly><Team/></PrivateRoute>}/>
            </Route>
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}
